import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { WinSourceCredentialsInputDTORuntype, WinSourceResponseBodyDTORuntype } from './winsourceBackendTypes';

export const winsourceEndpoints = {
    'GET /3rdparty/winsource/credentials': endpoint({
        description: 'Returns credentials for winsource integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: WinSourceResponseBodyDTORuntype,
    }),
    'POST /3rdparty/winsource/credentials': endpoint({
        description: 'Uploads credentials for winsource API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: WinSourceCredentialsInputDTORuntype,
        responseBody: WinSourceResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/winsource/credentials'],
    }),
    'PATCH /3rdparty/winsource/credentials': endpoint({
        description: 'Updates credentials for winsource API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: WinSourceCredentialsInputDTORuntype,
        responseBody: WinSourceResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/winsource/credentials'],
    }),
    'DELETE /3rdparty/winsource/credentials': endpoint({
        description: 'Deletes existing credentials for winsource API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted: z.number() }),
        invalidates: ['GET /3rdparty/winsource/credentials'],
    }),
};
